import { render, staticRenderFns } from "./FinancesInvoices.vue?vue&type=template&id=b327ffce&scoped=true&lang=pug"
import script from "./FinancesInvoices.vue?vue&type=script&lang=js"
export * from "./FinancesInvoices.vue?vue&type=script&lang=js"
import style0 from "./FinancesInvoices.vue?vue&type=style&index=0&id=b327ffce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b327ffce",
  null
  
)

export default component.exports